import { FC, ReactNode } from 'react';

interface DisputeSectionHeaderProps {
  text: ReactNode;
}

const DisputeSectionHeader: FC<DisputeSectionHeaderProps> = ({ text }) => (
  <h2 className="mb-3 text-sbase font-semibold text-accentText">{text}</h2>
);

export default DisputeSectionHeader;
